export default "__VITE_ASSET__v3PX_wet__"